/* Resolve where to send the user when they click a "Get started / Activate AI" CTA.
   - Not logged in → /login
   - Logged in, onboarding done → /dashboard
   - Logged in, onboarding incomplete → /onboarding/step-<N>
*/
export function resolveCtaTarget(user) {
    if (!user) return "/login";
    const step = user.onboarding_step || "1";
    if (step === "done") return "/dashboard";
    if (step === "4") return "/onboarding/step-3"; // legacy
    return `/onboarding/step-${step}`;
}
